import { Feature } from "@modules/feature-revision-history/models/feature-revision";
import { createAction, props, union } from "@ngrx/store";

import { ClaimInfo } from "../../models/feature-revision/claim-info";
import { FeatureListForm } from "../../models/feature-revision/feature-list";

export const getClaimFeaturesWithPreReq = createAction(
  "[FRH List] Get Claim Features With Prerequisites",
  props<{ claimNumber: string; showSpinner?: true }>()
);

export const getClaimFeaturesWithPreReqSuccess = createAction(
  "[FRH List] Get Claim Features With Prerequisites Success",
  props<{
    claimNumber: string;
    claimInfo: ClaimInfo | null;
    features: Feature[];
  }>()
);

export const refreshClaimInfoAndFeatures = createAction(
  "[FRH List] Referesh ClaimInfo and Features",
  props<{
    claimInfo: ClaimInfo | null;
    features: FeatureListForm[];
  }>()
);

export const clearReq = createAction("[FRH List] clear Req");

const all = union({
  getClaimFeaturesWithPreReq,
  getClaimFeaturesWithPreReqSuccess,
  refreshClaimInfoAndFeatures,
  clearReq,
});

export type ListActionsUnion = typeof all;
